module.exports = __webpack_public_path__ + "images/VivaEngageHeroBanner-40da55ac089fb16f307402ec11b13c2d.png";